export var TipoInstruccion3D;
(function (TipoInstruccion3D) {
    TipoInstruccion3D[TipoInstruccion3D["ASIGNORMAL"] = 0] = "ASIGNORMAL";
    TipoInstruccion3D[TipoInstruccion3D["ASIGARREGLO"] = 1] = "ASIGARREGLO";
    TipoInstruccion3D[TipoInstruccion3D["ARREGLOASIG"] = 2] = "ARREGLOASIG";
    TipoInstruccion3D[TipoInstruccion3D["ARREGLOASIGARREGLO"] = 3] = "ARREGLOASIGARREGLO";
    TipoInstruccion3D[TipoInstruccion3D["ETIQUETA"] = 4] = "ETIQUETA";
    TipoInstruccion3D[TipoInstruccion3D["GOTO"] = 5] = "GOTO";
    TipoInstruccion3D[TipoInstruccion3D["LLAMADA"] = 6] = "LLAMADA";
    TipoInstruccion3D[TipoInstruccion3D["PRINTF"] = 7] = "PRINTF";
    TipoInstruccion3D[TipoInstruccion3D["IF"] = 8] = "IF";
    TipoInstruccion3D[TipoInstruccion3D["RETURN"] = 9] = "RETURN";
    TipoInstruccion3D[TipoInstruccion3D["REPRESENTACION"] = 10] = "REPRESENTACION";
})(TipoInstruccion3D || (TipoInstruccion3D = {}));
